<template>
  <div class="text-xs-center" style="position:relative">

    <div v-if="editable">
      <Related v-model="newModel" :field="field" :hide-label="true" @change="changed($event)"></Related>
      <v-icon v-if="isEdited && editable" class="light-green--text form-field__icon--update" @click="update">check
      </v-icon>
    </div>

    <v-dialog v-else v-model="dialog" width="700">
    <v-progress-linear v-if="loading" :indeterminate="true">
    </v-progress-linear>
    <div v-else>
      <RelatedValueView v-if="relatedSchema && relatedValue" :relatedValue="relatedValue" :relatedSchema="relatedSchema" />
      <v-card v-else>
        <v-card-title>
          {{ $t('related.no_data') }}
        </v-card-title>
      </v-card>
    </div>
    <template v-slot:activator="{ on }">
      <v-btn color="black" outline round small @click="load()" v-on="on">{{ code }}</v-btn>
    </template>
  </v-dialog>

</div>
</template>

<script>
import http from '@/plugins/http'
import RelatedValueView from "@/components/related/value/ValueView"
import {input} from "@/mixins/input"
import Related from "@/components/form/inputs/Related.vue"

export default {
  mixins: [input],
  components: {
    RelatedValueView,
    Related
  },
  props: ["code", "field", "editable"],
  data() {
    return {
      newModel: "",
      dialog: false,
      archvieCopy: {},
      loading: true,
      relatedSchemaId: 0,
      relatedValue: null,


    }
  },
  watch: {
    code: function (newVal) {
      this.newModel = newVal
    }
  },
  computed: {
    isEdited() {
      return this.newModel !== this.code
    },
    relatedSchema() {
      try {
        return this.$store.state.relatedSchemas.find(relatedSchema => relatedSchema.id == this.relatedSchemaId)
      } catch (e) {
        return null
      }
    },
    locale: () => process.env.VUE_APP_LOCALE
  },
  created() {
    this.newModel = this.code
    if (this.field.options != undefined && this.field.options.relatedId != undefined) {
      this.relatedSchemaId = this.field.options.relatedId
    }
  },
  methods: {
    changed(e) {
      this.newModel = e
    },
    update() {
      this.$emit("updateField", this.newModel)
    },
    load() {
      this.dialog = true
      if (this.relatedValue == null) {
        http.get("related/schema/" + this.relatedSchemaId + "/values/code/" + this.code)
          .then(data => this.relatedValue = data.data)
          .catch(() => null)
          .finally(() => this.loading = false);
      }
    }
  }
}
</script>

<style lang="scss" scope>
@import '@/assets/css/main.scss';

.radio>label {
  font-size: 11px !important;
}

</style>
